import { BaseListStore } from './baseListStore';
import { DrawWallInfo, WallData, WallDataBase, WallDataExtra } from '@/editor/data/wall/Wall';
import { AbstractBaseListStore } from './abstractBaseListStore';
import { EEntityType } from '@/editor/types';
import { TGlobalStores } from '..';
import { initDrawWallInfo } from '@/editor/data/wall/utils';
import { WallBaseData } from '@/editor/data/wall/wallBaseData';

export class BaseWallStore implements AbstractBaseListStore<WallData> {
  private _wallBaseDataMap;
  private _wallExtraDataMap;

  constructor(gs: TGlobalStores) {
    this._wallBaseDataMap = new BaseListStore<WallDataBase>(gs, {
      keepOrder: true,
      dataType: EEntityType.Wall
    });
    this._wallExtraDataMap = new Map<string, WallDataExtra>();
  }

  add(data: WallData) {
    this._wallBaseDataMap.add({ id: data.id, baseData: data.baseData });
    this._wallExtraDataMap.set(data.id, { drawWallInfo: data.drawWallInfo });
  }

  update(_id: string, _data: WallData) {
    console.warn('can not update wall data directly');
  }

  updateBaseData(id: string, data: Partial<WallBaseData>) {
    if (!id || !data) return;

    const currentData = this._wallBaseDataMap.get(id);
    if (!currentData) return;

    this._wallBaseDataMap.update(id, { baseData: { ...currentData.baseData, ...data } });
  }

  updateShape(id: string, data: Partial<DrawWallInfo>) {
    if (!id || !data) return;
    const currentData = this._wallExtraDataMap.get(id);
    if (!currentData) return;
    this._wallExtraDataMap.set(id, { drawWallInfo: { ...currentData.drawWallInfo, ...data } });
  }

  remove(id: string) {
    if (!id || !this._wallBaseDataMap.get(id)) return;

    this._wallBaseDataMap.remove(id);
    this._wallExtraDataMap.delete(id);
  }

  get(id: string) {
    const baseData = this._wallBaseDataMap.get(id);
    if (!baseData) return;
    let extraData = this._wallExtraDataMap.get(id);
    if (!extraData) {
      extraData = { drawWallInfo: initDrawWallInfo(baseData.baseData) };
      this._wallExtraDataMap.set(id, extraData);
    }
    return {
      ...baseData,
      ...extraData
    };
  }

  getList() {
    return this._wallBaseDataMap.getList().flatMap((item) => {
      const wallData = this.get(item.id);
      return wallData ? [wallData] : [];
    });
  }

  clear() {
    this._wallBaseDataMap.clear();
    this._wallExtraDataMap.clear();
  }
}
